package com.ives.modules.measurements;

import js.Browser;
import js.html.svg.PathElement;

import com.ives.utils.math.Vector2D;

class MeasurementUtils {
	public static function drawMeasuredLine(fromX:Float, fromY:Float, toX:Float, toY:Float, ?showScale:Bool = false, scale:Float, scaleWidth:Float = 4):PathElement{
		var path:PathElement = cast Browser.document.createElementNS("http://www.w3.org/2000/svg", "path");

		var pathString:String = 'M ${fromX} ${fromY} L ${toX} ${toY} ';

		if(pathString.indexOf("NaN") == -1)
			path.setAttribute("d", pathString);

		if(!showScale)
			return path;

		var from:Vector2D = new Vector2D(fromX, fromY);
		var to:Vector2D = new Vector2D(toX, toY);
		var step:Vector2D = to.subtract(from);
		var length:Float = step.length();
		var perpendicular:Vector2D = new Vector2D(-step.y, step.x);

		step.normalize();
		step.scale(scale);
		perpendicular.normalize();
		perpendicular.scale(scaleWidth);

		pathString += 'M ${fromX} ${fromY} ';

		var scaled:Float = 0;
		var position:Vector2D = new Vector2D(fromX, fromY);
		var n:UInt = 0;

		while(scaled < length){
			var tickSize:Float = 1;

			if(n % 10 == 0)
				tickSize = 4;

			pathString += 'M ${position.x + tickSize * perpendicular.x} ${position.y + tickSize * perpendicular.y} ';
			pathString += 'L ${position.x - tickSize * perpendicular.x} ${position.y - tickSize * perpendicular.y} ';

			n++;

			scaled += scale;
			position = position.add(step);
		}

		path.setAttribute("d", pathString);

		return path;
	}
}
